import React, { useState, useEffect } from 'react';
import '../components/main.css';
import resume from '../static/Jia_Raymond-Resume.pdf';
import rays_image from '../static/rjia_full_nobckgrnd_fade.png';
import gt_seal from '../static/georgia_tech_seal.png';
import okta_logo from '../static/okta_logo.png';
import l3harris_logo from '../static/l3harris_logo.png';
import tribe_logo from '../static/tribe_logo.png';
import cds_logo from '../static/cds_logo.png';
import Grad from './education/Grad';
import Undergrad from './education/Undergrad';
import OktaIntern from './experience/OktaIntern';
import L3harrisIntern from './experience/L3harrisIntern';
import CommonDataSet from './other/CommonDataSet';
import TribeSite from './other/TribeSite';

function Home() {
  // function transform(section) {
  //   const offsetTop = section.parentElement.offsetTop;
  //   const scrollSection = section.querySelector('.scroll-section');
  //   let percentage = ((window.scrollY - offsetTop) / window.innerHeight) * 100;
  //   percentage = percentage < 0 ? 0 : percentage > 0 ? 100 : percentage;
  //   // scrollSection.style.transform = `translate3d(${-(percentage)}vw, 0, 0)`;
  // };

  // const handleScroll = (e) => {
  //   const stickySections = [...document.querySelectorAll('.sticky')];
  //   for(let i = 0; i < stickySections.length; i++) {
  //     transform(stickySections[i]);
  //   }
  // }

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll)
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  const [education, setEducation] = useState(0);
  const [experience, setExperience] = useState(0);
  const [other, setOther] = useState(0);

  useEffect(() => {
    const container = document.querySelector('.super-scroller');
    container.addEventListener('wheel', (event) => {
      event.preventDefault();
      const delta = event.deltaY;

      container.scrollBy({
        top: delta,
        behavior: "smooth"
      });
    })
  }, []);

  const selectedStyle = {
    borderLeft: "2px solid #172440",
    backgroundColor: "#f1f3f3",
    cursor: "default"
  }

  return (
    <main>
      <div className="super-scroller">
        <section>
          <div className="container introduction">
            <div className="introduction-left">
              <div className="introduction-content">
                <img className="profile-picture" src={rays_image}/>
              </div>
            </div>
            <div className="introduction-right">
              <div className="introduction-content">
                <h5>Hello, I'm</h5>
                <h1>Raymond</h1>
                <p className = "introduction-description">
                  I'm a Software Engineer at Okta and an Instructional Associate at Georgia Tech for OMSCS/CS 6601.
                </p>
                <a className="resume-button" href={resume} target="_blank">Resume</a>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="card">
            <div className='selection-bar'>
              <div className='selection' style={education === 0 ? selectedStyle : null} onClick={() => setEducation(0)}>
                <img className='card-selection-logo' src={gt_seal}/>
              </div>
              <div className='selection' style={education === 1 ? selectedStyle : null} onClick={() => setEducation(1)}>
                <img className='card-selection-logo' src={gt_seal}/>
              </div>
            </div>
            {
              education === 0 && <Grad/>
            }
            {
              education === 1 && <Undergrad/>
            }
          </div>
        </section>
        {/* <section>
          <div className="card">
            <div className='selection-bar'>
              <div className='selection' style={experience === 0 ? selectedStyle : null} onClick={() => setExperience(0)}>
                <img className='card-selection-logo' src={okta_logo}/>
              </div>
              <div className='selection' style={experience === 1 ? selectedStyle : null} onClick={() => setExperience(1)}>
                <img className='card-selection-logo' src={l3harris_logo}/>
              </div>
            </div>
            {
              experience === 0 && <OktaIntern/>
            }
            {
              experience === 1 && <L3harrisIntern/>
            }
          </div>
        </section> */}
        {/* <section>
          <div className="card">
            <div className='selection-bar'>
              <div className='selection' style={other === 0 ? selectedStyle : null} onClick={() => setOther(0)}>
                <img className='card-selection-logo' src={cds_logo}/>
              </div>
              <div className='selection' style={other === 1 ? selectedStyle : null} onClick={() => setOther(1)}>
                <img className='card-selection-logo' src={tribe_logo}/>
              </div>
            </div>
            {
              other === 0 && <CommonDataSet/>
            }
            {
              other === 1 && <TribeSite/>
            }
          </div>
        </section> */}
      </div>
      {/* 
      <div className="sticky-parent">
        <div className="sticky">
          <div className="scroll-section">
            <div className="card">
              <div className='card-content'>
                <h2>Okta</h2>
                <h4>Software Engineering Intern</h4>
                <h5>Summer 2023</h5>
                <h5>San Francisco, CA</h5>
                <p>
                  Description here
                </p>
              </div>
            </div>
            <div className="card">
              <div className='card-content'>
                <h2>L3Harris Technologies</h2>
                <h4>Software Engineering Intern</h4>
                <h5>Summer 2021</h5>
                <h5>Melbourne, FL - Remote</h5>
                <p>
                  Description here
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky-parent">
        <div className="sticky">
          <div className="scroll-section">
            <div className="card">
              <div className='card-content'>
                <h2>Jersey Ordering Site</h2>
                <h4>React</h4>
                <h5>February 2023</h5>
                <p>
                  Description here
                </p>
              </div>
            </div>
            <div className="card">
              <div className='card-content'>
                <h2>Ultilytics</h2>
                <h4>React</h4>
                <h5>April 2023 - Ongoing</h5>
                <p>
                  Description here
                </p>
              </div>
            </div>
            <div className="card">
              <div className='card-content'>
                <h2>Common Data Set</h2>
                <h4>React, D3.js</h4>
                <h5>November 2023 - Ongoing</h5>
                <p>
                  Description here
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className="container introduction">
          <div className="introduction-left">
            <div className="introduction-content">
              <img className="profile-picture" src={rays_image}/>
            </div>
          </div>
          <div className="introduction-right">
            <div className="introduction-content">
              <p style={{width: '70%'}}>
                End with a section about my hobbies/activities (frisbee, GTSO, IEEE HKN) and a link to the main site
              </p>
            </div>
          </div>
        </div>
      </section> */}
    </main>
  );
}

export default Home;